// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import ToastrController from "./toastr_controller"
application.register("toastr", ToastrController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import DeleteController from "./delete_controller"
application.register("delete", DeleteController)

import GeneralController from "./general_controller"
application.register("general", GeneralController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import ScheduleChangeFormController from "./schedule_change_form_controller"
application.register("schedule-change-form", ScheduleChangeFormController)

import EmployeeHiringRequestFormController from "./employee_hiring_request_form_controller"
application.register("employee-hiring-request-form", EmployeeHiringRequestFormController)

// document.addEventListener("turbo:frame-render", (event) => {
//   const frameId = event.target.id
//   console.log(`Turbo frame rendered: ${frameId}`)
//   // Ensure Stimulus reconnects to dynamically added content
//   if (frameId === "upload_preview") {
//     console.log("Reconnecting Stimulus for upload_preview frame")
//     const application = window.Stimulus
//     if (application) {
//       application.load()
//     }
//   }
// })
